<template>

    <div id="primary-attorney-display" class="panel panel-primary" v-if="primaryAttorney != false">
        <div class="panel-heading">Primary Attorney</div>
        <div class="panel-body">
            <p class="fullname">{{ primaryAttorney.user.firstName }}{{ primaryAttorney.user.lastName }}</p>
            <div class="contact-block">
                <p><i class="fa fa-envelope-o"></i> <a :href="'mailto:' + primaryAttorney.user.email" class="email-link">{{ primaryAttorney.user.email }}</a></p>
            </div>
        </div>
    </div>

</template>



<script>

    import { Store } from '@/store.js'

    export default {

        name: 'primaryAttorneyDisplay',
        
        data() {
            return {
                store: Store
            }
        },

        computed: {
            primaryAttorney: function() {
                if (Object.keys(this.store.data.currentDocumentSet).length) {
                    var pa = this.store.data.currentDocumentSet.userLinks.filter( function(u) {
                        return u.relationType === 'primary_attorney'
                    })
                    if (!!pa.length) {
                        return pa.pop()
                    } else { return false }
                } else {
                    return false
                }
            }
        }
    }
    
</script>



<style lang="scss" scoped>

    @import "../variables";

    #primary-attorney-display {
        font-size: .8em;
        text-align: left;

        p {
            margin: 0;
        }

        .panel-heading {
            font-weight: 600;
        }

        .fullname {
            font-weight: 600;
        }

        .contact-block {
            font-size: .8em;
        }
    }

</style>



// WEBPACK FOOTER //
// PrimaryAttorneyDisplay.vue?7c520c10